// Betriebsschließungstage as a set of days, for marking the calendar and refusing leave. The
// backend answers the same question per user, so the two have to agree on the arithmetic.

// A plain `YYYY-MM-DD` is midnight UTC, whose local getters answer the day before west of
// UTC. Same reasoning as utils/dateConverter.js.
const PLAIN_DATE = /^(\d{4})-(\d{2})-(\d{2})/;

/** A bare date field read field by field, never through `new Date(iso)`. */
export function toLocalDate(value) {
    if (!value) return null;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
    const m = String(value).match(PLAIN_DATE);
    const d = m
        ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
        : new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}

export function toIsoDay(value) {
    const d = toLocalDate(value);
    if (!d) return null;
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${month}-${day}`;
}

/** Every day of a span as `YYYY-MM-DD`, both ends included. */
export function daysInSpan(start, end) {
    const from = toLocalDate(start);
    const to = toLocalDate(end) || from;
    if (!from || !to || to < from) return [];
    const out = [];
    for (let d = new Date(from); d <= to; d.setDate(d.getDate() + 1)) {
        out.push(toIsoDay(d));
    }
    return out;
}

/** The closed days keyed by day. `userId` drops the closures that user is excepted from; omitting
 *  it keeps every closure, which is what an admin's org-wide calendar wants. */
export function closureDayMap(closures, userId = null) {
    const map = new Map();
    (closures || []).forEach(closure => {
        const excepted = (closure.exception_user_ids || []).map(String);
        if (userId != null && excepted.includes(String(userId))) return;
        daysInSpan(closure.start_date, closure.end_date).forEach(day => {
            if (!map.has(day)) map.set(day, closure);
        });
    });
    return map;
}

/** The days of `start`..`end` that are already closed — what blocks a leave request. */
export function closedDaysInSpan(start, end, dayMap) {
    if (!dayMap || dayMap.size === 0) return [];
    return daysInSpan(start, end).filter(day => dayMap.has(day));
}

/** German date for a message, without pulling in the table formatter's padding rules. */
export function listDays(days, max = 5) {
    const shown = days.slice(0, max).map(d => {
        const [y, m, day] = d.split('-');
        return `${day}.${m}.${y}`;
    });
    return shown.join(', ') + (days.length > max ? ` (+${days.length - max})` : '');
}
